// extracted by mini-css-extract-plugin
export default {"alertBoxWrapper":"Alert_alertBoxWrapper__uEjiB"};